import React, { memo } from "react";

import { Spinner } from "@at/design-system-elements";
import { useFederatedQuery } from "@at/sauron-platform-graphql";

// import { LeasingGalleryFallback } from "./leasing-gallery.styled";
import type {
  LeasingPDPImagesQuery,
  LeasingPDPImagesQueryVariables,
  LeasingPDPImagesQuery_vehicle_Vehicle_images_ImageUrl,
} from "../../../connected-components/hoc/query/__generated__/pdp-images.fed.query";

import { leasingPDPImagesQuery } from "../../../connected-components/hoc/query/pdp-images.fed.query";
import { Gallery } from "../../gallery/gallery";
import type { LeasingPDPImagesProps } from "../../gallery/gallery.types";

interface LeasingGalleryProps {
  generationId: string;
  paintColour: string | undefined;
  trim: string | undefined;
  make: string;
  advertImages?: readonly LeasingPDPImagesProps[];
}

export const LeasingGalleryComponent = ({
  generationId,
  paintColour: paint,
  trim,
  make,
  advertImages = [],
}: LeasingGalleryProps) => {
  const makeIsMini = make === "MINI";
  const { data, loading, error } = useFederatedQuery<
    LeasingPDPImagesQuery,
    LeasingPDPImagesQueryVariables
  >(leasingPDPImagesQuery, {
    variables: { generationId, paint, trim },
    skip: advertImages.length > 0 || makeIsMini,
  });

  if (loading) {
    return <Spinner attributes={{ "data-testid": "spinner" }} />;
  }

  if (error) {
    return null;
  }

  const images: ReadonlyArray<LeasingPDPImagesQuery_vehicle_Vehicle_images_ImageUrl> =
    advertImages.length > 0 ? [...advertImages] : data?.vehicle?.images ?? [];

  return (
    <>
      {/* <Suspense fallback={<LeasingGalleryFallback />}> */}
      <Gallery {...{ advertImages: images, isLeasingPDPPage: true }} />
      {/* </Suspense> */}
    </>
  );
};

export const LeasingGallery = memo(LeasingGalleryComponent);
